export default {
    title: "Gestione Documenti",
    subtitle: "Configura document types, schemi, attributi e training per l'agente AI",
    tabs: {
        types: "Tipi Documento",
        attributes: "Attributi Documento",
        connections: "Doc Connection Manager",
        training: "Training",
    },
    types: {
        title: "Tipi Documento",
        description: "Gestisci i tipi di documenti disponibili nel sistema",
        newDocumentType: "Nuovo Tipo Documento",
        filters: {
            keywordPlaceholder: "Cerca per keyword...",
            attributePlaceholder: "Filtra per attributo specifico",
            attributeSearchPlaceholder: "Cerca attributo...",
            allAttributes: "Tutti gli attributi",
            groupBy: "Raggruppa per",
            groupByNone: "Nessuno",
            groupByPhase: "Fase",
            groupByCategory: "Categoria",
            ungrouped: "Non raggruppati",
            expandAll: "Espandi Tutti",
            collapseAll: "Comprimi Tutti",
        },
        headers: {
            key: "Chiave",
            label: "Etichetta",
            description: "Descrizione",
            phase: "Fase",
            category: "Categoria",
            schemasCount: "Num. Schemi",
            attributesCount: "Num. Attributi",
            createdAt: "Data Creazione",
            actions: "Azioni",
        },
        actions: {
            edit: "Modifica",
            delete: "Elimina",
            viewSchemas: "Schemi",
            viewAttributes: "Attributi",
        },
        modal: {
            new: "Nuovo Tipo Documento",
            edit: "Modifica Tipo Documento",
            updateSuccess: "Tipo documento aggiornato con successo",
            createSuccess: "Tipo documento creato con successo",
            fields: {
                key: "Chiave",
                keyPlaceholder: "es: bill_of_lading",
                label: "Etichetta",
                labelPlaceholder: "es: Polizza di Carico",
                description: "Descrizione",
                descriptionPlaceholder: "Descrizione del tipo di documento",
                phase: "Fase",
                phasePlaceholder: "es: INVIO SPEDIZIONE",
                category: "Categoria",
                categoryPlaceholder: "es: Documenti di trasporto",
            },
        },
    },
    schemas: {
        title: "Schemi Documento",
        description: "Gestisci gli schemi per ogni tipo di documento con varianti verticali",
        newSchema: "Nuovo Schema",
        searchPlaceholder: "Cerca per nome, tipo...",
        documentTypePlaceholder: "Filtra per tipo documento",
        documentTypeSearchPlaceholder: "Cerca tipo documento...",
        regionPlaceholder: "Filtra per regione",
        statusPlaceholder: "Filtra per stato",
        headers: {
            documentType: "Tipo Documento",
            schemaName: "Nome Schema",
            schemaCode: "Codice",
            region: "Regione",
            attributeCount: "Attributi",
            parserRulesCount: "Regole Parser",
            isDefault: "Default",
            isActive: "Stato",
            createdAt: "Data Creazione",
            actions: "Azioni",
        },
        modal: {
            new: "Nuovo Schema",
            edit: "Modifica Schema",
            duplicateTitle: "Duplica schema",
            duplicateDescription: "Inserisci nome e codice per il nuovo schema. Il resto delle informazioni e gli attributi saranno copiati dallo schema sorgente.",
            fields: {
                documentType: "Tipo Documento",
                documentTypePlaceholder: "Seleziona tipo documento",
                documentTypeSearch: "Cerca tipo documento...",
                schemaName: "Nome Schema",
                schemaNamePlaceholder: "es: WayBill China/Asia",
                schemaCode: "Codice Schema",
                schemaCodePlaceholder: "es: waybill_china_asia",
                version: "Versione",
                versionPlaceholder: "es: 1.0",
                description: "Descrizione",
                descriptionPlaceholder: "Descrizione dello schema",
                useCases: "Casi d'Uso",
                useCasesPlaceholder: "Quando usare questo schema",
                region: "Regione",
                regionPlaceholder: "es: asia, europe",
                countryCodes: "Codici Paese",
                countryCodesPlaceholder: "es: CN, JP, KR",
                carrierCodes: "Codici Vettore",
                carrierCodesPlaceholder: "es: MAEU, MSC",
                isDefault: "Schema Default",
                isActive: "Attivo",
            },
        },
        actions: {
            edit: "Modifica",
            delete: "Elimina",
            duplicate: "Duplica",
            viewAttributes: "Gestisci Attributi",
            parserRules: "Regole Parser",
        },
        status: {
            active: "Attivo",
            inactive: "Inattivo",
            default: "Default",
        },
        messages: {
            loadError: "Errore nel caricamento degli schemi",
            createSuccess: "Schema creato con successo",
            updateSuccess: "Schema aggiornato con successo",
            saveError: "Errore nel salvataggio dello schema",
            deleteSuccess: "Schema eliminato con successo",
            deleteError: "Errore nell'eliminazione dello schema",
            saving: "Salvataggio...",
            duplicateSuccess: "Schema duplicato con successo",
            duplicateError: "Errore nella duplicazione dello schema",
            duplicateValidation: "Inserisci nome e codice per il nuovo schema",
            duplicating: "Duplicazione...",
        },
    },
    schemaAttributes: {
        title: "Attributi Schema",
        description: "Gestisci gli attributi per questo schema",
        backToSchemas: "Torna agli Schemi",
        newAttribute: "Aggiungi Attributo",
        searchPlaceholder: "Cerca attributo...",
        headers: {
            attributeKey: "Chiave",
            label: "Etichetta",
            type: "Tipo",
            importance: "Importanza",
            required: "Obbligatorio",
            enumValues: "Valori Enum",
            metadata: "Metadata",
            actions: "Azioni",
        },
        modal: {
            new: "Aggiungi Attributo",
            edit: "Modifica Attributo",
            createNewAttribute: "Crea Nuovo Attributo",
            useExistingAttribute: "Usa Attributo Esistente",
            fields: {
                attribute: "Attributo",
                attributeSearch: "Cerca attributo...",
                attributePlaceholder: "Seleziona attributo esistente",
                importanceLevel: "Livello Importanza",
                importanceLevelPlaceholder: "Seleziona livello",
                importanceLevels: {
                    error: "Errore se mancante",
                    warning: "Avviso se mancante",
                    optional: "Opzionale",
                },
                isRequired: "Obbligatorio",
                displayOrder: "Ordine Visualizzazione",
                customLabel: "Etichetta Personalizzata",
                customLabelPlaceholder: "Override etichetta (opzionale)",
                customHelpText: "Testo Aiuto Personalizzato",
                customHelpTextPlaceholder: "Override testo aiuto (opzionale)",
            },
        },
        importance: {
            error: "Errore",
            warning: "Avviso",
            optional: "Opzionale",
        },
        actions: {
            edit: "Modifica",
            remove: "Rimuovi",
        },
    },
    attributes: {
        title: "Attributi Globali",
        description: "Gestisci attributi riusabili per tutti gli schemi",
        newAttribute: "Nuovo Attributo",
        searchPlaceholder: "Cerca per chiave, etichetta...",
        dataTypePlaceholder: "Filtra per tipo dato",
        dataTypeSearchPlaceholder: "Cerca tipo dato...",
        categoryPlaceholder: "Filtra per categoria",
        categorySearchPlaceholder: "Cerca categoria...",
        globalPlaceholder: "Filtra per globale",
        headers: {
            attributeKey: "Chiave",
            label: "Etichetta",
            dataType: "Tipo Dato",
            category: "Categoria",
            isGlobal: "Globale",
            usageCount: "Utilizzi",
            createdAt: "Data Creazione",
            actions: "Azioni",
        },
        modal: {
            new: "Nuovo Attributo",
            edit: "Modifica Attributo",
            fields: {
                attributeKey: "Chiave Attributo",
                attributeKeyPlaceholder: "es: shipper_name",
                label: "Etichetta",
                labelPlaceholder: "es: Nome Spedizioniere",
                description: "Descrizione",
                descriptionPlaceholder: "Descrizione dell'attributo",
                dataType: "Tipo Dato",
                dataTypePlaceholder: "Seleziona tipo dato",
                dataTypeSearch: "Cerca tipo dato...",
                enumValues: "Valori Enum",
                enumValuesPlaceholder: "Aggiungi valori (uno per riga)",
                enumValuesHelp: "Solo per tipo enum",
                metadata: "Metadata",
                metadataPlaceholder: '{"key": "value"}',
                metadataHelp: "Solo per tipo json - JSON valido",
                validationRules: "Regole Validazione",
                validationRulesPlaceholder: '{"min": 0, "max": 100}',
                inputType: "Tipo Input",
                inputTypePlaceholder: "es: text, number, date",
                placeholder: "Placeholder",
                placeholderPlaceholder: "Testo placeholder",
                helpText: "Testo Aiuto",
                helpTextPlaceholder: "Testo di aiuto per l'utente",
                category: "Categoria",
                categoryPlaceholder: "es: parties, cargo, dates",
                displayOrder: "Ordine Visualizzazione",
                isGlobal: "Globale",
            },
        },
        actions: {
            edit: "Modifica",
            delete: "Elimina",
        },
        dataTypes: {
            string: "Stringa",
            number: "Numero",
            date: "Data",
            datetime: "Data/Ora",
            boolean: "Booleano",
            array: "Array",
            object: "Oggetto",
            email: "Email",
            url: "URL",
            phone: "Telefono",
        },
    },
    connections: {
        title: "Doc Connection Manager",
        description: "Collega attributi di schemi di document type diversi per facilitare la validazione cross-documento",
        newConnection: "Nuova Connessione",
        searchPlaceholder: "Cerca connessione...",
        headers: {
            source: "Sorgente",
            target: "Destinazione",
            validationRule: "Regola Validazione",
            created: "Creato",
            actions: "Azioni",
        },
        modal: {
            new: "Nuova Connessione",
            edit: "Modifica Connessione",
            source: "Sorgente",
            target: "Destinazione",
            fields: {
                sourceDocumentType: "Tipo Documento Sorgente",
                sourceSchema: "Schema Sorgente",
                sourceAttribute: "Attributo Sorgente",
                targetDocumentType: "Tipo Documento Destinazione",
                targetSchema: "Schema Destinazione",
                targetAttribute: "Attributo Destinazione",
                searchDocumentType: "Cerca tipo documento...",
                searchAttribute: "Cerca attributo...",
                validationRule: "Regola di Validazione",
            },
        },
        validationRules: {
            mustMatch: "Devono corrispondere",
            mustBeDifferent: "Devono essere diversi",
            sourceContainsTarget: "Sorgente contiene Destinazione",
            targetContainsSource: "Destinazione contiene Sorgente",
            mustReference: "Deve fare riferimento",
            mustBeSimilar: "Devono essere simili",
        },
        actions: {
            edit: "Modifica",
            delete: "Elimina",
        },
    },
    training: {
        title: "Training Documenti",
        description: "Carica documenti per il training dell'agente AI",
        uploadDocuments: "Carica Documenti",
        uploadArea: "Trascina file qui o clicca per selezionare",
        supportedFormats: "Formati supportati: PDF, PNG, JPG, XLSX, XLS, CSV",
        searchPlaceholder: "Cerca documento...",
        documentTypePlaceholder: "Filtra per tipo",
        documentTypeSearchPlaceholder: "Cerca tipo documento...",
        statusPlaceholder: "Filtra per stato",
        headers: {
            fileName: "Nome File",
            documentType: "Tipo",
            status: "Stato",
            uploadDate: "Data Upload",
            extractionScore: "Score Estrazione",
            validationScore: "Score Validazione",
            detectedSchema: "Schema Rilevato",
            actions: "Azioni",
        },
        status: {
            pending: "In Attesa",
            processing: "Elaborazione",
            completed: "Completato",
            failed: "Fallito",
        },
        validationStatus: {
            correct: "Corretto",
            incorrect: "Non Corretto",
            pending: "Da Validare",
        },
        actions: {
            viewDetails: "Dettagli",
            delete: "Elimina",
            correct: "Corretto",
            incorrect: "Non Corretto",
            loading: "Caricamento...",
        },
        breadcrumb: {
            trainingDocuments: "Training Documents",
        },
        detail: {
            title: "Dettaglio processo di training",
            backToList: "Torna alla lista",
            documentTitle: "Documento",
            extractedDataTitle: "Dati Estratti per Provider",
            infoTitle: "Info Processo e Training",
            notFound: {
                title: "Documento non trovato",
                message: "Il documento di training richiesto non esiste.",
                backToList: "Torna alla lista",
            },
            infoFields: {
                documentType: "Tipo Documento",
                status: "Status",
                dataset: "Dataset",
                datasetVersion: "Versione Dataset",
                schema: "Schema",
                detectedSchema: "Schema Rilevato",
                extractionScore: "Score Estrazione",
                validationScore: "Score Validazione",
                createdAt: "Data Creazione",
                updatedAt: "Ultimo Aggiornamento",
                aiProviders: "Provider AI Utilizzati",
                customVariables: "Variabili Custom",
                notes: "Note",
            },
            tableHeaders: {
                attribute: "Attributo",
                extractedValue: "Valore Estratto",
                confidence: "Confidenza",
                validationStatus: "Stato Validazione",
                actions: "Azioni",
            },
            actions: {
                title: "Azioni Documento",
            },
            extraction: {
                title: "Esegui Estrazione",
                strategy: "Strategia",
                run: "Avvia Estrazione",
                running: "Estrazione in corso...",
                success: "Estrazione completata con successo",
                error: "Errore durante l'estrazione",
                results: "Risultati Estrazione",
                confidence: "Confidenza",
                duration: "Durata",
                cost: "Costo",
                tokens: "Token",
                selectAsBest: "Seleziona come Migliore",
                selected: "Estrazione selezionata come migliore",
                selectError: "Errore nella selezione",
                noExtractions: "Nessuna estrazione. Avvia un'estrazione per vedere i risultati.",
                ocrOutput: "Output OCR",
                extractedFields: "Campi Estratti",
            },
            classification: {
                run: "Classifica Documento",
                running: "Classificazione in corso...",
                success: "Classificazione completata: {{type}} ({{confidence}}%)",
                error: "Errore durante la classificazione",
                description: "Rileva automaticamente il tipo di documento",
            },
            jobHistory: {
                title: "Storico Job",
                noJobs: "Nessun job ancora. Avvia un'estrazione o classificazione per vedere lo storico.",
                headers: {
                    type: "Tipo",
                    strategy: "Strategia",
                    status: "Stato",
                    confidence: "Confidenza",
                    duration: "Durata",
                    date: "Data",
                },
                status: {
                    pending: "In attesa",
                    processing: "In elaborazione",
                    completed: "Completato",
                    failed: "Fallito",
                },
                type: {
                    parsing: "Parsing",
                    classification: "Classificazione",
                },
                details: {
                    model: "Modello",
                    tokens: "Token",
                    cost: "Costo",
                    completedAt: "Completato il",
                    error: "Errore",
                },
            },
            fields: {
                headers: {
                    field: "Campo",
                    value: "Valore",
                    confidence: "Confidenza",
                    validation: "Validazione",
                },
                correct: "Corretto",
                incorrect: "Non corretto",
                edit: "Modifica",
                markCorrect: "Segna come corretto",
                markIncorrect: "Segna come non corretto",
                enterValue: "Inserisci valore...",
                enterJson: "Inserisci JSON...",
                updateSuccess: "Campo aggiornato con successo",
                updateError: "Errore nell'aggiornamento del campo",
                markedCorrect: "Campo segnato come corretto",
                markedIncorrect: "Campo segnato come non corretto",
                validateError: "Errore nella validazione del campo",
                loadError: "Errore nel caricamento dei campi",
                noFields: "Nessun campo estratto",
                array: "Array",
                object: "Oggetto",
            },
        },
        modal: {
            details: "Dettagli Elaborazione",
            fields: {
                fileName: "Nome File",
                documentType: "Tipo Documento",
                datasetName: "Nome Dataset",
                datasetVersion: "Versione Dataset",
                status: "Stato",
                extractionScore: "Score Estrazione",
                validationScore: "Score Validazione",
                detectedSchema: "Schema Rilevato",
                processingTime: "Tempo Elaborazione",
                extractedFields: "Campi Estratti",
                validationIssues: "Problemi Validazione",
            },
        },
        upload: {
            success: "Documenti caricati con successo",
            error: "Errore nel caricamento",
            processing: "Elaborazione in corso...",
        },
        batchOcr: {
            selected: "{{count}} selezionati",
            runOcr: "Avvia OCR",
            clearSelection: "Annulla selezione",
            progressTitle: "Batch OCR",
            status: {
                submitted: "Inviato",
                processing: "In corso...",
                completed: "Completato",
                partiallyCompleted: "Parziale",
                failed: "Fallito",
            },
            failedCount: "{{count}} documenti falliti",
            messages: {
                submitted: "Batch OCR avviato per {{count}} documenti",
                submitError: "Errore nell'avvio del batch OCR",
                completed: "Batch OCR completato con successo",
                partiallyCompleted: "Batch OCR completato con errori",
                failed: "Batch OCR fallito",
            },
        },
        batchActions: {
            runParsing: "Avvia Parsing",
            runClassification: "Classifica",
            delete: "Elimina",
            strategyModal: {
                title: "Seleziona Strategia di Parsing",
                description: "Scegli la strategia di estrazione da utilizzare per {{count}} documenti.",
                strategyLabel: "Strategia",
            },
            deleteModal: {
                title: "Conferma Eliminazione",
                description: "Sei sicuro di voler eliminare {{count}} documenti? Questa azione non può essere annullata.",
            },
            messages: {
                parsingSubmitted: "Parsing avviato per {{count}} documenti",
                parsingError: "Errore nell'avvio del batch parsing",
                classificationSubmitted: "Classificazione avviata per {{count}} documenti",
                classificationError: "Errore nell'avvio della classificazione batch",
                deleteSuccess: "{{count}} documenti eliminati",
                deleteError: "Errore nell'eliminazione dei documenti",
            },
        },
    },
    parserRules: {
        title: "Regole Parser",
        description: "Gestisci le regole in Natural Language per l'agente Parser",
        status: {
            active: "Attiva",
            inactive: "Inattiva",
        },
        priority: "Priorità",
        actions: {
            add: "Aggiungi Regola",
            edit: "Modifica",
            delete: "Elimina",
            duplicate: "Duplica",
            cancelEdit: "Annulla Modifica",
            confirmDelete: {
                title: "Conferma Eliminazione",
                message: 'Sei sicuro di voler eliminare la regola "{{name}}"? Questa azione non può essere annullata.',
            },
            confirmDuplicate: {
                title: "Duplica Regola",
                message: 'Sei sicuro di voler duplicare la regola "{{name}}"? Verrà creata una nuova regola con la stessa configurazione.',
            },
        },
        modal: {
            title: "Regole Parser",
            existingRules: "Regole Esistenti",
            noRules: "Nessuna regola definita per questo schema",
            addRule: "Aggiungi Nuova Regola",
            editRule: "Modifica Regola",
            fields: {
                ruleName: "Nome Regola",
                ruleNamePlaceholder: "es: Validazione Codice Container",
                naturalLanguageRule: "Regola in Natural Language",
                naturalLanguageRulePlaceholder: "Scrivi la regola in linguaggio naturale che l'agente Parser deve seguire...",
                naturalLanguageRuleHelp: "Descrivi in linguaggio naturale come l'agente deve trattare il documento una volta classificato con questo schema",
                description: "Descrizione",
                descriptionPlaceholder: "Descrizione opzionale della regola",
                priority: "Priorità",
                isActive: "Attiva",
            },
        },
    },
    modal: {
        cancel: "Annulla",
        save: "Salva",
        create: "Crea",
        delete: "Elimina",
        close: "Chiudi",
        confirmDelete: "Conferma Eliminazione",
        confirmDeleteMessage: "Sei sicuro di voler eliminare questo elemento? Questa azione non può essere annullata.",
    },
    loading: "Caricamento...",
    noData: {
        title: "Nessun dato disponibile",
        message: "Non ci sono elementi da visualizzare",
        createFirst: "Crea il primo elemento",
    },
    breadcrumb: {
        documentTypes: "Tipi Documento",
        schemas: "Schemi",
        attributes: "Attributi",
    },
    common: {
        yes: "Sì",
        no: "No",
        selectFile: "Seleziona File",
        selectedFiles: "File selezionati:",
        upload: "Carica",
        selectAttribute: "Seleziona un attributo",
        selectAtLeastOneFile: "Seleziona almeno un file",
        insertAliasPerLine: "Inserisci un alias per riga",
        invalidJson: "JSON non valido",
        global: "Globale",
        specific: "Specifico",
    },
};
